import { SNETButton } from "shared/dist/components/domainless/data-entry";
import { SNETDialog } from "shared/dist/components/domainless/overlay/dialog";
import classes from "./WarningDialog.module.css";
import { GlobalRoutes } from "../../../../../GlobalRouter/Routes";

export const WarningDialog = ({ onCancel, onOk, ...rest }) => {
    return (
        <SNETDialog
            title="Warning!"
            contentClass={classes.content}
            onDialogClose={onCancel}
            {...rest}
        >
            <div className={classes.content}>
                <div className={classes.description}>
                    You can initiate a deployment, but it will only be visible (on the{" "}
                    <a href={GlobalRoutes.MY_DEPLOYMENTS.path}>My Deployments</a> page) to the
                    creator of the daemon deployment, and only they can top up account and pay for
                    it. Are you sure?{" "}
                </div>
                <div className={classes["buttons-holder"]}>
                    <SNETButton variant="outlined" onClick={onCancel}>
                        Discard
                    </SNETButton>
                    <SNETButton onClick={onOk}>Yes</SNETButton>
                </div>
            </div>
        </SNETDialog>
    );
};
